Object.defineProperty(exports, "__esModule", { value: true });
exports.textModelConfig = void 0;
exports.textModelConfig = {
    textSection: {
        fields: {
            variation: {
                items: ['text'],
                type: 'dropdown',
            },
            text: {
                required: true,
                translations: {
                    name: {
                        nl: 'Tekst',
                    },
                    helpText: {
                        nl: 'Eenvoudig opgemaakte tekstveld met kopjes en afbeeldingen',
                    },
                },
                type: 'richText',
            },
            eventId: {
                initialContent: 'initial-content-for-text-section-event-id',
                translations: {
                    helpText: {
                        'en-US': 'Example: my-event-id',
                        nl: 'Voorbeeld: mijn-event-id',
                    },
                },
                type: 'shortText',
                typePostfix: 'Slug',
                unique: true,
            },
        },
        modelVersion: '1.0.0',
        settings: {
            asBoilerplate: false,
            asFragment: true,
            asPageSection: true,
        },
    },
};
//# sourceMappingURL=text-model-config.js.map